import React from 'react';

import { LAUNCH_A11Y, LAUNCH_DATE_LABEL, LAUNCH_EYEBROW } from '../launch';
import css from './LaunchCorner.module.css';

/**
 * FairwayBid: der umgeknickte Seitenrand auf dem großen Startseitenbild.
 *
 * Wie die umgeknickte Ecke einer Zeitschriftenseite – die Rückseite ist rot
 * bedruckt und trägt den Starttermin. Der Termin ist die einzige Information
 * auf der Startseite, die eine Frist ist; deshalb steht er nicht im Fließtext,
 * sondern in der Ecke, wo man ihn sieht, bevor man liest.
 *
 * Beim Überfahren hebt sich die Ecke vom Bild ab. Das ist keine Deko: Papier,
 * das sich anheben lässt, erkennt man als Papier – der Knick wird dadurch
 * erst als Knick gelesen und nicht als aufgeklebtes Dreieck.
 *
 * Aufbau: ".sheet" ist das umgeschlagene Blatt und trägt die Bewegung,
 * darin liegen Fläche, Falz und Beschriftung. Sie heben sich gemeinsam,
 * weil sie ein Stück Papier sind.
 */
const LaunchCorner = () => (
  <div className={css.corner}>
    <span className={css.sheet} aria-hidden="true">
      <span className={css.fold} />
      <span className={css.crease} />
      <span className={css.label}>
        <span className={css.eyebrow}>{LAUNCH_EYEBROW}</span>
        <span className={css.date}>{LAUNCH_DATE_LABEL}</span>
      </span>
    </span>
    <span className={css.spoken}>{LAUNCH_A11Y}</span>
  </div>
);

export default LaunchCorner;
